import { render, staticRenderFns } from "./TramitesView.vue?vue&type=template&id=15223170"
import script from "./TramitesView.vue?vue&type=script&lang=ts"
export * from "./TramitesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports